import styled from 'styled-components';
import { colors } from 'globalStyles';

export const StyledCheckbox = styled.div`
  width: 100%;
  line-height: 20px;
  height: 20px;
  font-size: 12px;
  color: ${colors.BODY};
`;
export const Label = styled.label``;

export const Input = styled.input`
  display: none;

  &:checked + div {
    background-color: ${colors.LIGHT_GREEN};
    border: solid 2px ${colors.LIGHT_GREEN};
  }

  &:checked + div:after {
    content: '';
    display: block;
    position: relative;
    left: 5px;
    width: 4px;
    height: 12px;
    border: solid ${colors.WHITE};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

export const Indicator = styled.div`
  float: left;
  width: 20px;
  height: 20px;
  border: solid 2px ${colors.LIGHTER_GRAY};
  border-radius: 2px;
  transition: .1s;
  margin-right: 12px;

  &:hover {
    cursor: pointer;
  }
`;



// WEBPACK FOOTER //
// ./src/components/CheckboxField/styledComponents.js